export const APP_BRIDGE_URL =
  'https://cdn.shopify.com/shopifycloud/app-bridge.js';
